
export const FETCH_CAMPAIGN_LIST_BEGIN   = 'FETCH_CAMPAIGN_LIST_BEGIN';
export const FETCH_CAMPAIGN_LIST_SUCCESS = 'FETCH_CAMPAIGN_LIST_SUCCESS';
export const FETCH_CAMPAIGN_LIST_FAILURE = 'FETCH_CAMPAIGN_LIST_FAILURE';

export const fetchCampaignListBegin = () => ({
  type: FETCH_CAMPAIGN_LIST_BEGIN
});

export const fetchCampaignListSuccess = (data, opts) => ({
  type: FETCH_CAMPAIGN_LIST_SUCCESS,
  payload: data,
  opts
});

export const fetchCampaignListFailure = error => ({
  type: FETCH_CAMPAIGN_LIST_FAILURE,
  payload: { error }
});


export function fetchCampaignList(opts = {}) {
  return (dispatch, getState) => {
    dispatch(fetchCampaignListBegin(opts));
    let url = '/manager/campaigns/dashboard/campaign_list.json';
    fetch(`${url}/?${$.param({ page: opts.page, except: opts.except })}`)
      .then((response) => response.json())
      .then((data) => { dispatch(fetchCampaignListSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(fetchCampaignListFailure(error, opts)));
  };
}
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
